import {
  contentService,
  type CompleteUploadRequest,
  type InitiateUploadRequest,
} from "@/lib/api/content";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "./use-toast";

export const useInitiateUpload = (type: "audio" | "video") => {
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: InitiateUploadRequest) => {
      return contentService.initiateUpload(type, data);
    },
    onError: (error) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to initiate upload. Please try again.";

      toast({
        title: "Upload Error",
        description: errorMessage,
        variant: "destructive",
      });
    },
  });
};

export const useCompleteUpload = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      type,
      data,
    }: {
      type: "audio" | "video";
      data: CompleteUploadRequest;
    }) => {
      return contentService.completeUpload(type, data);
    },
    onSuccess: (response) => {
      toast({
        title: "Upload Complete",
        description: response.message,
      });
      // Invalidate content list query
      queryClient.invalidateQueries({ queryKey: ["/api/content"] });
    },
    onError: (error) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to complete upload. Please try again.";

      toast({
        title: "Upload Error",
        description: errorMessage,
        variant: "destructive",
      });
    },
  });
};
